<style>
.btn-gray {
    color: white;
    background: gray;
    border: 1px solid #e7eaec;
}
</style>

<template>
<v-modal :show.sync="show" effect="zoom">
  <div slot="modal-header" class="modal-header" style="display: none;">
    <h4 class="modal-title" >
    </h4>
  </div>
  <div slot="modal-body" class="modal-body">
    <div class="row text-center" id="danger-icon">
      <span class="fa-stack fa-5x">
        <i class="fa fa-circle-thin fa-stack-2x text-danger" aria-hidden="true"></i>
        <i class="fa fa-exclamation fa-stack-1x text-danger"></i>
      </span>
    </div>
    <h2 class="text-center">
    Weet u het zeker?
    </h2>
    <div class="row text-center">
      <button type="button" class="btn btn-lg btn-gray" @click="show = false">Annuleren</button>
      <button type="button" class="btn btn-lg btn-danger" @click="callback" >Ja, Verwijder</button>
    </div>
  </div>
  <div slot="modal-footer" class="modal-footer" style="display: none;">
  </div>
</v-modal>
</template>

<script>
import modal from './Modal'

export default {
  name: 'DeleteSweetAlert',
  props: {
    callback: {
      type: Function,
      default () {}
    },
    show: {
      type: Boolean
    }
  },
  components: {
    'v-modal': modal
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  ready () {
  },
  methods: {
  }
}
</script>




// WEBPACK FOOTER //
// deleteSweetAlert.vue?1e8a9074